import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import { BaseRow } from '@app/components/common/BaseRow/BaseRow';
import styled from 'styled-components';

export const Btn = styled(BaseButton)`
  width: 100%;
`;

export const CenteredRow = styled(BaseRow)<{ showCancel: boolean; showSave: boolean }>`
  display: flex;
  justify-content: ${({ showCancel, showSave }) => (showCancel && showSave ? 'space-between' : 'center')};
  align-items: center;
  width: 100%;
`;